<template>
  <a-card>
    <template slot="title">
      <Status :status="source.status ? 'Active' : 'Not Active'" v-if="getScreen"/>
      <h4 class="margin-remove">
        Manifest Amandemen Sales Contract
        <Status v-if="!getScreen" :status="source.status ? 'Active' : 'Not Active'" />
      </h4>
      <small>{{ source.no_sales_contract }}</small>
    </template>

    <div :class="!getScreen ? 'info-header' : 'info-header mobile'">
      <span> No Amandemen Ke : {{ source.no_amandemen }} </span>
      <span> {{ `${source.last_update} | ${source.tlc}` }} </span>
    </div>

    <a-table :rowKey="(record, index) => {return index;}" :columns="columns" bordered :data-source="source.changes" :scroll="{x: 800}">
      <span slot="no" slot-scope="item, record, index">
        {{ index + 1 }}
      </span>
      <div slot="before" slot-scope="item">
        <template v-if="!Array.isArray(item.before)">
          <h4 class="margin-remove">{{ item.title.toUpperCase() }}</h4>
          <span>{{ item.before }}</span>
        </template>
        <template v-else>
          <h4 class="margin-remove">{{ item.title.toUpperCase() }}</h4>
          <ul class="list">
            <li v-for="(data, index) in item.before" :key="index">
              <h4 class="margin-remove">{{ data.label.toUpperCase() }}</h4>
              <span>{{ data.value }}</span>
            </li>
          </ul>
        </template>
      </div>
      <div slot="after" slot-scope="item">
        <template v-if="!Array.isArray(item.after)">
          <h4 class="margin-remove">{{ item.title.toUpperCase() }}</h4>
          <span>{{ item.after }}</span>
        </template>
        <template v-else>
          <h4 class="margin-remove">{{ item.title.toUpperCase() }}</h4>
          <ul class="list">
            <li v-for="(data, index) in item.after" :key="index">
              <h4 class="margin-remove">{{ data.label.toUpperCase() }}</h4>
              <span>{{ data.value }}</span>
            </li>
          </ul>
        </template>
      </div>
    </a-table>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";
export default {
  name: "amandemen-history",
  props: ["id"],
  component: { Status },
  data() {
    const columns = [
      {
        title: "No",
        dataIndex: "no",
        key: "no",
        width: 80,
        align: "center",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Before",
        key: "before",
        scopedSlots: { customRender: "before" },
      },
      {
        title: "After",
        key: "after",
        scopedSlots: { customRender: "after" },
      },
    ];
    return {
      columns,
      source: {},
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getScreen"]),
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.$store
        .dispatch("getHistorySC", { auth: this.getAuth, payload: this.$route.params.id_ })
        .then((res) => {
          this.source = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: @margin;

  &.mobile{
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.list {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  padding-left: @padding;
  li {
    padding: @padding 0;
    border-bottom: 1px solid darken(white, 10);
    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }
}
</style>